"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAutoResizeTextarea = useAutoResizeTextarea;
var _react = require("react");
const MAX_HEIGHT_PX = 160;
function resize(el) {
  if (!el) return;
  el.style.height = "auto";
  const nextHeight = Math.min(el.scrollHeight, MAX_HEIGHT_PX);
  el.style.height = "".concat(nextHeight, "px");
  el.style.overflowY = el.scrollHeight > MAX_HEIGHT_PX ? "auto" : "hidden";
}

// Ported from ConversationHelper.js's autoResizeTextarea, wrapped so it
// re-runs whenever the caller's tracked value (deps) changes, e.g. the
// message draft text, in addition to being callable directly on input events.
function useAutoResizeTextarea(textareaRef) {
  let deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  (0, _react.useEffect)(() => {
    resize(textareaRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return (0, _react.useCallback)(() => resize(textareaRef.current), [textareaRef]);
}